<template>
    <div
        id="griglia-visualizzazione-foto"
        v-bind:class="[isArticlesModalVisible ? 'bg-light popup-laterale-aperto' : 'bg-light']"
    >
        <vue-headful :title="pageTitle" />
        <div class="body-wrapper">
            <gallery-header />

            <main>
                <div class="container-fluid mt-5">
                    <h2 class="titolo-album text-uppercase text-center mb-0">
                        {{ title }} <span class="scritta-galleriafoto">Galleria foto</span>
                    </h2>

                    <div class="row align-items-center">
                        <div class="info-album col-sm-6 col-lg-8 mt-4">
                            <p class="numero-foto mb-0 text-sm-left">
                                {{ numPhotos }} {{ $t("foto") }}
                            </p>
                        </div>

                        <div class="azioni-album col-sm-6 col-lg-4 mt-4">
                            <ul class="d-flex justify-content-center justify-content-sm-end mb-0">
                                <!--
                                <li>
                                <a href="#"><i class="far fa-images d-block d-sm-inline"></i> Confronta</a>
                                </li>
                                -->

                                <!--
                                <li>
                                <a href="#"><i class="fas fa-play d-block d-sm-inline"></i> Galleria</a>
                                </li>
                                -->

                                <li v-if="!isAuthor && isOrderable && numPhotos <= 50">
                                    <a
                                        @click="showArticlesModal({})"
                                        href="javascript:void(0)"
                                        class="btn btn-dark btn-rikorda1 btn-sm pulsante-acquista-tutto"
                                    >
                                        <font-awesome-icon
                                            :icon="['fas', 'shopping-cart']"
                                            class="d-inline"
                                        />
                                        &nbsp;{{ $t("Acquista tutto") }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="visualizzazione-foto mt-5">
                    <div class="container-fluid">

                        <gallery-masonry-wall
                            :items="loadedPhotos"
                            :options="{ padding: 5, throttle: 500 }"
                            class=""
                            @append="loadMore"
                        >
                            <template v-slot:default="{item}">
                                <gallery-photo-card
                                    :key="item.id"
                                    :photo="item"
                                    :viewOnly="isAuthor"
                                    :orderable="isOrderable"
                                    @showArticlesModal="showArticlesModal"
                                    @photoClicked="showAlbumSlideshow"
                                    @loaded="onPhotoLoaded"
                                ></gallery-photo-card>
                            </template>
                        </gallery-masonry-wall>

                        <!--
                        <div
                            v-infinite-scroll="loadMore"
                            infinite-scroll-disabled="busy"
                            infinite-scroll-distance="10"
                            class="elenco-foto card-columns"
                        >
                            <! - -
                            card-columns è la classe di bootstrap per fare il masonry (per altri tipi di layout bisogna toglierla;
                            posso copiare gli stili messi da questa classe all'elemento e ai suoi child mettendoli nel css tema-01)
                            - - >
                            <gallery-photo-card
                                v-for="photo in loadedPhotos"
                                :key="photo.id"
                                :photo="photo"
                                :viewOnly="isAuthor"
                                :orderable="isOrderable"
                                @showArticlesModal="showArticlesModal"
                                @photoClicked="showAlbumSlideshow"
                            ></gallery-photo-card>
                        </div>
-->
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>

        <b-overlay
            class="overlay"
            :show="isArticlesModalVisible"
            :variant="'dark'"
            :opacity="0.75"
            no-wrap
        >
            <template v-slot:overlay>
                <div></div>
            </template>
        </b-overlay>

        <articles-modal
            ref="articlesModal"
            v-show="isArticlesModalVisible"
            :favorites="false"
            @close="hideArticlesModal"
            @addedToCart="onAddedToCart"
            @removedFromCart="onRemovedFromCart"
        />
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import GalleryPhotoCard from "../../components/gallery/PhotoCard";
import ArticlesModal from "../../components/gallery/ArticlesModal";
import GalleryMasonryWall from "../../components/gallery/MasonryWall";

export default {
    name: "GalleryAlbum",
    components: {
        GalleryHeader,
        GalleryFooter,
        GalleryPhotoCard,
        ArticlesModal,
        GalleryMasonryWall
    },

    data() {
        return {
            busy: true,
            author: null,
            title: null,
            pageTitle: null,
            gallery: null,
            photos: [],
            scrollStep: 10,
            loadedPhotos: [],
            isArticlesModalVisible: false,
            loadingCounter: 0,
            maxLoading: 2
        };
    },

    computed: {
        numPhotos() {
            return this.photos ? this.photos.length : 0;
        },

        isAuthor() {
            return this.$store.getters.isAuthor;
        },

        isOrderable() {
            return this.gallery && this.gallery.orderable;
        }
    },

    created() {
        this.$store
            .dispatch("GET_GALLERY_DATA", {
                albumId: this.$route.params.albumId
            })
            .then((result) => {
                console.debug("GET_GALLERY_DATA", result);
                this.gallery = result.gallery;
                this.photos = result.photos;
                this.photos.forEach((photo) => {
                    photo.loadingAllowed = false;
                });
                this.scrollStep = result.scrollStep;
                this.author = this.gallery.author;
                this.title = this.gallery.title;
                this.setPageTitle();
                this.busy = false;
                /*this.$nextTick(() => {
                    //this.$refs.masonry.reset();
                    this.loadMore();
                });*/
                this.$nextTick(() => {
                    this.handleLoading(this);
                });
            })
            .catch((error) => {
                console.error("GET_GALLERY_DATA", error);
                this.$router.push({
                    name: "gallery-dashboard",
                    params: {
                        galleryUrl: this.$route.params.galleryUrl
                    }
                });
            })
            .finally(() => {});
    },

    methods: {
        setPageTitle() {
            if (this.gallery) {
                this.pageTitle = [
                    this.gallery.title,
                    this.$t("di"),
                    this.gallery.author,
                    "- Rikorda"
                ].join(" ");
            }
        },

        handleLoading(scope) {
            var photosToLoad = scope.loadedPhotos.filter((p) => {
                return !p.loadingAllowed;
            });
            while (
                scope.loadingCounter < scope.maxLoading &&
                photosToLoad.length > 0
            ) {
                var photoToLoad = photosToLoad.shift();
                photoToLoad.loadingAllowed = true;
                scope.loadingCounter++;
            }

            if (
                photosToLoad.length > 0 ||
                scope.loadedPhotos.length < scope.photos.length
            ) {
                setTimeout(scope.handleLoading, 200, scope);
            }
        },

        onPhotoLoaded() {
            this.loadingCounter--;
        },

        loadMore() {
            if (this.loadedPhotos.length < this.photos.length) {
                this.busy = true;

                var start = this.loadedPhotos.length;
                for (let i = 0; i < this.scrollStep; i++) {
                    let idx = start + i;
                    if (this.photos.length > idx) {
                        this.loadedPhotos.push(this.photos[idx]);
                    }
                }

                this.busy = false;
            }
        },

        showArticlesModal(photo) {
            this.$refs.articlesModal.photoData = photo;
            this.$refs.articlesModal.numPhotos = this.numPhotos;
            this.$refs.articlesModal.selectedArticleQt = 1;

            return this.$refs.articlesModal
                .getPriceSheetData()
                .then((response) => {
                    this.isArticlesModalVisible = response;
                });
        },

        hideArticlesModal() {
            this.isArticlesModalVisible = false;
        },

        showAlbumSlideshow(photoId) {
            this.$router.push({
                name: "gallery-album-photo",
                params: {
                    galleryUrl: this.$route.params.galleryUrl,
                    albumId: this.$route.params.albumId,
                    photoId: photoId
                }
            });
        },
        onAddedToCart(photo) {
            // controllo per aggiunta al carrello di una foto singola o di tutte le foto
            var photos = photo ? [photo] : this.photos;
            photos.forEach((photo) => {
                photo.inCart = true;
            });
        },

        onRemovedFromCart(photo) {
            // controllo per rimozione dal carrello di una foto singola o di tutte le foto
            if (photo) {
                photo.inCart = false;
            }
        }
    }
};
</script>

<style></style>
